import axios from "axios";

const remoteAxios = axios.create();

export { remoteAxios };
